module.exports = __webpack_public_path__ + "img/resolve.7e9d3b5d.png";